export default Object.freeze({
  isObstruction: 'Encombrements',
  isDiastema: 'Diastèmes',
  isRotation: 'Rotations',
  isVersion: 'Versions',
  isOverhang: 'Surplomb',
  isRelapse: 'Récidive',
});
